export function singleDateStrategy(date, newDate) {
  return [newDate];
}
